import { IconArrowNarrowLeft } from '@tabler/icons-react'
import clsx from 'clsx'
import Link from 'next/link'

import { ListingCategoryType } from 'modules/products'
import LinkButton from 'shared/ui/Button/LinkButton'

import styles from './CategoryFilters.module.scss'

type CategoryFiltersProps = {
  backLinkDetails: {
    label: string
    path: string
  }
  categoriesToDisplay: ListingCategoryType[]
  deliveryDates: string[]
  category: ListingCategoryType | null
}

const CategoryFilters = ({
  backLinkDetails,
  categoriesToDisplay,
  category
}: CategoryFiltersProps) => {
  return (
    <div className={styles.filtersWrapper}>
      <LinkButton
        className={styles.previousButton}
        href={backLinkDetails?.path || ''}
        title={backLinkDetails?.label || ''}
        variant='tertiaryText'
        size='small'
        startIcon={<IconArrowNarrowLeft />}
      >
        {backLinkDetails?.label || ''}
      </LinkButton>

      <div className={styles.subcategoriesWrapper}>
        <h3 className={styles.subcategoriesTitle}>Podkategorie:</h3>
        {categoriesToDisplay.map((el: ListingCategoryType) => {
          return (
            <Link
              className={styles.subcategoryItem}
              key={el.id}
              href={el?.totalSlug || ''}
              title={el.name}
            >
              <h4
                className={clsx(styles.subcategoryName, {
                  [styles.subcategoryNameActive]: el.id === category?.id
                })}
              >
                {el.name}
              </h4>
              <div className={styles.numberOfSubcategories}>
                ({el.productsCount})
              </div>
            </Link>
          )
        })}
      </div>
      {category?.lead && <div className={styles.leadDescription}>{category.lead}</div>}
    </div>
  )
}

export default CategoryFilters
